import { EVENT_STATUS } from "./util/eventStatusConfig";

// Action identifiers
export const EVENT_ACTIONS =  Object.freeze({
  VIEW: "view",
  EDIT: "edit",
  CAPTURE: "capture",
  CANCEL: "cancel",
  CONCLUDE: "conclude",
  ADD_CAPTURER: "add_capturer",
});

/**
 * BUSINESS RULE:
 * Decide which actions apply to an event
 */
export function getEventActions(event) {
  const { statusText, participants, owner } = event;

  // Non-owners: NO actions at all
  if (!owner) {
    return [];
  }

  // OWNER ONLY actions
  switch (statusText) {
    case EVENT_STATUS.APPROVED: {
      // Always allowed for Approved events
      const actions = [
        { key: EVENT_ACTIONS.ADD_CAPTURER, label: "Add Capturers" },
        { key: EVENT_ACTIONS.EDIT, label: "View / Edit" },
      ];

      // Participants may be undefined or missing
      const participantCount = typeof participants === "number" ? participants : 0;

      // Approved + no participants → Edit & Cancel
      if (participantCount === 0) {
        actions.push({ key: EVENT_ACTIONS.CANCEL, label: "Cancel Event", });
      }

      // Approved + participants → Edit & Conclude
      else {
        actions.push({ key: EVENT_ACTIONS.CONCLUDE, label: "Conclude Event", });
      }

      return actions;
    }

    // Submitted / In Progress → Edit & Cancel
    case EVENT_STATUS.SUBMITTED:
    case EVENT_STATUS.IN_PROGRESS:
      return [
        { key: EVENT_ACTIONS.ADD_CAPTURER, label: "Add Captures" },
        { key: EVENT_ACTIONS.EDIT, label: "View / Edit" },
        { key: EVENT_ACTIONS.CANCEL, label: "Cancel Event" },
      ];

    // Any other status (Concluded, Archived, Rejected, etc.)
    // OWNER can still View
    default:
      return [{ key: EVENT_ACTIONS.VIEW, label: "View" }];
  }
}

/**
 * BUSINESS RULE:
 * Confirmation + backend dependency for each action
 */
export const ACTION_CONFIRMATION_CONFIG = {

  [EVENT_ACTIONS.ADD_CAPTURER]: {
    requiresBackend: true,
  },

  [EVENT_ACTIONS.VIEW]: {
    requiresBackend: true,
  },

  [EVENT_ACTIONS.EDIT]: {
    requiresBackend: true,
  },

  [EVENT_ACTIONS.CAPTURE]: {
    requiresBackend: false, // explicitly offline‑safe
  },


  [EVENT_ACTIONS.CANCEL]: {
    mode: "modal",
    requiresBackend: true,
    requiresReason: true,
    minReasonLength: 10,
    danger: true,
    title: (event) => `Cancel "${event?.title}" Event`,
    description:
      "This will mark the event as cancelled and prevent any attendance capture. This action cannot be undone.",
  },

  [EVENT_ACTIONS.CONCLUDE]: {
    mode: "modal",
    requiresBackend: true,
    requiresReason: false,
    danger: false,
    title: (event) => `Conclude "${event?.title}" Event`,
    description:
      "This will mark the event as concluded and prevent further attendance capture. This action cannot be undone.",
  },

};
